import {
  BaseClass,
  IGraph,
  ILabel,
  ILabelModel,
  ILabelModelParameter,
  ILookup,
  INode,
  IOrientedRectangle,
  OrientedRectangle,
  Rect,
} from '@ardoq/yfiles';
import {
  MODERNIZED_BLOCK_DIAGRAM_EXPANDER_SIZE as EXPANDER_SIZE,
  MODERNIZED_BLOCK_DIAGRAM_GROUP_PADDING as PADDING,
} from '../consts';
import {
  AGGREGATED_COUNT_BADGE_RADIUS,
  CollapsibleGraphGroup,
  estimateCountLabelWidth,
  type YGraphState,
} from '@ardoq/graph';
import {
  measureNodeLabel,
  MODERNIZED_BLOCK_DIAGRAM_LINE_HEIGHT as LINE_HEIGHT,
} from '@ardoq/graph-labeling';
import {
  MODERNIZED_BLOCK_DIAGRAM_EXPANDER_MARGIN_RIGHT as EXPANDER_MARGIN_RIGHT,
  MODERNIZED_BLOCK_DIAGRAM_LABEL_MAX_LINES as MAX_LINES,
} from 'yfilesExtensions/styles/modernized/consts';
import { wrapString } from 'tabview/blocks/misc/string';
import { ensureHeaderLayout } from '../ensureHeaderLayout';
import { LabelModelParameter } from '../LabelModelParameter';

class GroupLabelModel extends BaseClass(ILabelModel) {
  constructor(private graph: IGraph) {
    super();
  }
  createParameter(): ILabelModelParameter {
    return new LabelModelParameter(this);
  }
  override getContext(_label: ILabel): ILookup {
    return ILookup.EMPTY;
  }
  override getGeometry(
    label: ILabel,
    _: ILabelModelParameter
  ): IOrientedRectangle {
    const { owner, text } = label;
    if (!(owner instanceof INode)) {
      return IOrientedRectangle.EMPTY;
    }
    const {
      layout: { x: nodeX, y: nodeY, width: nodeWidth },
      tag,
    } = owner;
    const graphGroup = tag as CollapsibleGraphGroup;
    const { collapsed, descendantCount } = graphGroup;
    const left = nodeX + PADDING + EXPANDER_SIZE + 2;
    if (collapsed) {
      const descendantCountBadgeWidth = Math.max(
        estimateCountLabelWidth(descendantCount),
        2 * AGGREGATED_COUNT_BADGE_RADIUS
      );
      const leftWidth = PADDING + EXPANDER_SIZE + EXPANDER_MARGIN_RIGHT;
      const rightWidth = PADDING + descendantCountBadgeWidth + PADDING;
      const availableWidth = nodeWidth - leftWidth - rightWidth;
      const wrappedMainLabel = wrapString(
        text,
        availableWidth,
        measureNodeLabel,
        MAX_LINES
      );
      const top = nodeY + PADDING;
      const height = wrappedMainLabel.length * LINE_HEIGHT;
      return new OrientedRectangle(new Rect(left, top, availableWidth, height));
    }
    const { tag: graphTag } = this.graph;
    const { groupHeaders } = graphTag as YGraphState;
    const groupHeader = ensureHeaderLayout(owner, groupHeaders);
    if (!groupHeader) {
      return IOrientedRectangle.EMPTY;
    }
    const { mainLabelHeight } = groupHeader;
    const availableWidth = nodeWidth - 2 * PADDING;

    return new OrientedRectangle(
      new Rect(left, nodeY + PADDING, availableWidth, mainLabelHeight)
    );
  }
}
export { GroupLabelModel };
